export default __webpack_public_path__ + "static/email-sparkle-e9f7cb672c9e5c7693171b552197ac01.jpg";